// import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { services } from '../pages/Sell/services';
import { Typography, useMediaQuery, Box, Paper } from '@mui/material';
import { BASE_URL } from '../services/fetch';
import { useTheme } from '@mui/material/styles';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { useEffect, useMemo, useState } from 'react';

export default function BuybackTable({ trigger }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [rows, setRows] = useState([]);

  useEffect(() => {
    services.getSellVolumeStats().then(data => {
      const dailySeparatedTransactions = data.reduce((acc, curr) => {
        const truncDate = new Date(curr.createdAt)
          .toString()
          .slice(0, 15)
          .replaceAll(' ', '-');
        const isExisting = Object.keys(acc).find(t => t === truncDate);
        if (!isExisting) {
          acc[truncDate] = [curr];
        } else {
          acc[truncDate] = [...acc[truncDate], curr];
        }
        return acc;
      }, {});
      let totalShit = [];
      for (let key in dailySeparatedTransactions) {
        const wholeCurrDay = dailySeparatedTransactions[key].reduce(
          (acc, curr) => {
            acc.totalWeight += curr.gramVolume;
            acc.totalPrice += curr.gramVolume * curr.sellPrice;
            acc.totalESTJTPrice += curr.gramVolume * curr.ESTJTPrice;
            acc.totalMethghalPrice += curr.gramVolume * curr.methghalPrice;
            return acc;
          },
          {
            totalWeight: 0,
            totalPrice: 0,
            totalESTJTPrice: 0,
            totalMethghal: 0,
            totalMethghalPrice: 0,
          }
        );

        const todaySum = {};
        todaySum['ESTJTPrice'] = (
          wholeCurrDay.totalESTJTPrice / wholeCurrDay.totalWeight
        ).toFixed(0);
        todaySum['sellPrice'] = (
          wholeCurrDay.totalPrice / wholeCurrDay.totalWeight
        ).toFixed(0);
        todaySum['gramVolume'] = wholeCurrDay.totalWeight;
        todaySum['methghalPrice'] = (
          wholeCurrDay.totalMethghalPrice / wholeCurrDay.totalWeight
        ).toFixed(0);
        todaySum['id'] = key;
        todaySum['percentageDifferenceWithESTJT'] = (
          (todaySum['sellPrice'] / todaySum['ESTJTPrice'] - 1) *
          100
        ).toFixed(2);

        todaySum['createdAt'] = new Date(
          dailySeparatedTransactions[key][0].createdAt
        );

        todaySum['isSum'] = true;

        totalShit = [
          ...totalShit,
          todaySum,
          ...dailySeparatedTransactions[key],
        ];
      }

      setRows(totalShit);
    });
  }, [trigger]);

  const columns = useMemo(
    () => [
      {
        field: 'createdAt',
        sortable: false,
        filterable: false,
        headerName: 'تاریخ',
        minWidth: isMobile ? 140 : 160,
        flex: isMobile ? 0 : 0.8,
        renderCell: params => {
          const isSum = params.row.isSum;
          const date = new Date(params.value);
          if (!isSum) {
            return (
              <Typography variant="body2" color="text.secondary">
                {date.toLocaleString('fa-IR').slice(11)}
              </Typography>
            );
          }
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: '#3b82f6',
                }}
              />
              <Typography variant="body2" fontWeight={600}>
                {date.toLocaleString('fa-IR').slice(0, 11)}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: '#64748b', mr: 0.5, fontWeight: 400 }}
              >
                (مجموع روزانه)
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'gramVolume',
        sortable: false,
        headerName: 'حجم (گرم)',
        minWidth: isMobile ? 100 : 120,
        flex: isMobile ? 0 : 0.6,
        renderCell: params => (
          <Typography variant="body2" fontWeight={params.row.isSum ? 600 : 400}>
            {Number(params.value).toLocaleString('fa-IR')}
          </Typography>
        ),
      },
      {
        field: 'sellPrice',
        sortable: false,
        headerName: 'قیمت هر گرم',
        minWidth: isMobile ? 110 : 130,
        flex: isMobile ? 0 : 0.7,
        renderCell: params => (
          <Typography variant="body2" fontWeight={params.row.isSum ? 600 : 400}>
            {Number(params.value).toLocaleString('fa-IR')}
          </Typography>
        ),
      },
      {
        field: 'percentageDifferenceWithESTJT',
        sortable: false,
        headerName: 'اختلاف',
        minWidth: isMobile ? 100 : 120,
        flex: isMobile ? 0 : 0.6,
        renderCell: params => {
          const val = Number(params.value);
          const Icon = val > 0 ? TrendingUp : TrendingDown;
          const color = val > 0 ? '#10b981' : val < 0 ? '#ef4444' : '#64748b';
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Icon sx={{ fontSize: 16, color }} />
              <Typography
                variant="body2"
                fontWeight={params.row.isSum ? 600 : 400}
                sx={{ color }}
              >
                {Math.abs(val).toLocaleString('fa-IR')}%
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'ESTJTPrice',
        sortable: false,
        headerName: 'مرجع قیمت',
        minWidth: isMobile ? 100 : 120,
        flex: isMobile ? 0 : 0.6,
        renderCell: params => (
          <Typography
            variant="body2"
            fontWeight={params.row.isSum ? 600 : 400}
            color="text.secondary"
          >
            {Number(params.value).toLocaleString('fa-IR')}
          </Typography>
        ),
      },
      {
        field: 'methghalPrice',
        sortable: false,
        headerName: 'مظنه',
        minWidth: isMobile ? 100 : 120,
        flex: isMobile ? 0 : 0.6,
        renderCell: params => (
          <Typography
            variant="body2"
            fontWeight={params.row.isSum ? 600 : 400}
            color="text.secondary"
          >
            {Number(params.value).toLocaleString('fa-IR')}
          </Typography>
        ),
      },
    ],
    [isMobile]
  );

  return (
    <Paper
      elevation={0}
      sx={{
        width: '100%',
        borderRadius: 3,
        overflow: 'hidden',
        border: '1px solid #e9eef3',
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)',
      }}
    >
      <div
        style={{
          height: isMobile ? 'auto' : 550,
          width: '100%',
          direction: 'rtl',
          overflowX: 'auto',
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[5, 10, 25]}
          rowHeight={isMobile ? 52 : 60}
          autoHeight={isMobile}
          disableColumnMenu
          disableVirtualization
          getRowClassName={params =>
            params.row.isSum ? 'summary-row' : 'transaction-row'
          }
          sx={{
            border: 'none',
            fontFamily: theme.typography.fontFamily,
            '& .MuiDataGrid-main': {
              overflow: 'auto',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#fafcff',
              borderBottom: '1px solid #e9eef3',
              fontSize: '0.85rem',
              fontWeight: 600,
              color: '#334155',
              '& .MuiDataGrid-columnHeader': {
                padding: isMobile ? '0 6px' : '0 12px',
              },
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #f1f5f9',
              padding: isMobile ? '6px 6px' : '10px 12px',
              fontSize: '0.85rem',
            },
            // Transaction rows: clean, minimal
            '& .transaction-row': {
              backgroundColor: '#ffffff',
              '&:hover': {
                backgroundColor: '#fafcff',
              },
            },
            // Summary rows: distinct but elegant
            '& .summary-row': {
              backgroundColor: `${'#d7fff2ff !important'}`,
              borderTop: '1px solid #e2e8f0',
              borderBottom: '1px solid #e2e8f0',
              position: 'sticky',
              top: 0,
              zIndex: 2,
              '& .MuiDataGrid-cell': {
                fontWeight: 500,
                color: '#0f172a',
                borderBottom: 'none',
              },
              '&:hover': {
                backgroundColor: '#d7fff2ff !important',
              },
            },
            // Remove footer border
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid #e9eef3',
              backgroundColor: '#fafcff',
            },
            // Pagination styling
            '& .MuiTablePagination-root': {
              color: '#334155',
            },
          }}
        />
      </div>
    </Paper>
  );
}

export function downloadFile(address, id) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  fetch(`${BASE_URL}api/transactions/invoice/${address}.pdf`, {
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);
      anchor.href = objectUrl;
      anchor.download = `invoice-${id}.pdf`;
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
    });
}
